import { IconButton, Button } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { createUIBuilderNewPage, editUIBuilderPage } from '../../../../utils/UiBuilderAPIUtils';
import { fetchAllUIBuilderPages } from '../../../property/propertySlice';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const UiBuilderPagesCreate = (props) => {
  const { toggleDrawer, page, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
  });

  useEffect(() => {
    if (page) {
      const currFields = { ...formData };
      currFields.name.value = page.name;
      setFormData(currFields);
    }
  }, [page]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        if (page) {
          await editUIBuilderPage(hotelId, page.id, formData.name.value, language);
          notificationManager('success', 'Page updated successfully');
        } else {
          await createUIBuilderNewPage(hotelId, formData.name.value, language);
          notificationManager('success', 'Page created successfully');
        }
        dispatch(fetchAllUIBuilderPages(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          page
            ? notificationManager('danger', 'Page updation failed')
            : notificationManager('danger', 'Page creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{page ? 'Edit Page' : 'New Page'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='w-100 px-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <span className='page-title-secondary'>Details</span>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-3'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid}
            >
              {page ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UiBuilderPagesCreate;
